// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oBFO","input":"styles_input__HwCp8"};